<template>
  <div>
    <PageAllow controller="StockOutOrders" action="index" />
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color">
      <v-row dense class="mx-5">
        <v-col cols="12" sm="12" md="4">
          <v-row dense align="center" class="pa-1">
            <SearcherDatetimeRangeWithRadio
              v-model="options"
              type="datetime"
              show-radios
              :radios="datetimeRadios"
            />
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" md="8" align-self="center">
          <v-row dense align="center" class="search-controls">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="px-0 py-0 caption font-weight-bold grey--text"
                  color="primary"
                  @click.stop="onSearch()"
                >
                  <v-icon small class="pe-1">fa-search</v-icon>
                  {{ $t("Search.search") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.searchTip") }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="caption font-weight-bold grey--text"
                  @click.stop="resetSearch()"
                >
                  <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                  {{ $t("Search.reset") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.resetTip") }}</span>
            </v-tooltip>
            <v-divider vertical />
            <v-btn
              class="caption font-weight-bold grey--text"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
              small
              text
              @click.stop="$store.commit('toggleSearchPanel')"
            >
              {{ $t("Search.pro") }}
              <v-icon small class="ps-1">{{
                $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
              }}</v-icon>
            </v-btn>
            <v-col>
              <v-btn
                v-if="
                  pageType != 2 &&
                  $permission.permissionAllow('StockOutOrders', 'add')
                "
                small
                color="primary"
                @click="checkActions()"
                class="ms-1 float-end"
              >
                <v-icon x-small class="pe-1">fa-plus</v-icon>
                {{ $t("CRUD.newInfo", [$t("stockOutOrders.ObjectName")]) }}
              </v-btn>
              <v-btn
                v-if="$permission.permissionAllow('StockOutOrders', 'export')"
                small
                dark
                color="print"
                class="px-2 me-2 mb-1 float-end"
                @click.stop="exportExcel()"
              >
                <v-icon x-small class="pe-1">fa-file-excel</v-icon>
                {{ $t("stockOutOrders.export") }}
              </v-btn>
              <v-btn
                v-if="shopSettings && shopSettings.shop_off_return_order == 1"
                small
                dark
                color="print"
                class="px-2 me-2 mb-1 float-end"
                @click.stop="shopOffReturnOrder()"
              >
                {{ $t("stockOutOrders.shop_off_return_order") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-expansion-panels
        v-model="$store.getters.panels"
        multiple
        flat
        accordion
      >
        <v-expansion-panel class="transparent-background-color">
          <v-expansion-panel-content>
            <v-row dense align="center">
              <v-col cols="12" sm="6" md="4">
                <SearcherKeyword
                  ref="stock_order_code"
                  v-model="options.stock_order_code"
                  @text="stockOutsKeyWord = $event"
                  :label="$t('stockOutOrders.stockOutsKeyword')"
                />
              </v-col>
              <v-col cols="12" sm="6" md="4" v-if="pageType == 1">
                <v-select
                  v-model="stockOutTypeSelected"
                  clearable
                  :items="$consts.stock_out_order.types"
                  :label="$t('stockOutOrders.Fields.stock_out_type')"
                >
                </v-select>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
                v-if="
                  pageType == 1 &&
                  stockOutTypeSelected &&
                  stockOutTypeSelected == 11
                "
              >
                <v-select
                  v-model="stockOutBrokenTypeSelected"
                  clearable
                  :items="$consts.stock_out_order.brokenType"
                  :label="$t('stockOutOrders.Fields.broken_type')"
                >
                </v-select>
              </v-col>
              <!-- 商品编码 -->
              <SearcherKeyword
                ref="material_code"
                v-model="options.material_code"
                @text="materialCode = $event"
                :label="$t('stockInOrders.materialKeyword')"
              />
              <v-col cols="12" sm="6" md="4">
                <SearcherStatus
                  v-model="options.status"
                  :label="$t('stockOutOrders.status.title')"
                  :items="[
                    $consts.stock_out_order.status[1],
                    $consts.stock_out_order.status[2],
                  ]"
                />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <SearcherCancelFlgs v-model="options.cancel_flgs" />
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <div class="mx-4 mb-4">
        <v-data-table
          :headers="headers"
          :items="stock_outs"
          :options.sync="options"
          :page.sync="paging.page"
          :server-items-length="paging.count"
          :loading="loading"
          multi-sort
          class="elevation-2 px-4 pt-1 sticky-table"
          id="sticky-table"
          :class="stickTableCols ? 'sticky-first-col sticky-last-col' : ''"
          fixed-header
          :footer-props="$t('$config.footer-props')"
        >
          <template v-slot:header.actions="{ header }">
            {{ header.text }}
            <v-icon x-small>fa-sliders-h</v-icon>
          </template>
          <!-- 出库单编号/创建时间 -->
          <template v-slot:item.stock_order_code="{ item, index }">
            <span
              class="text-no-wrap caption font-weight-bold"
              :v-resize="!index ? $stickTableResizer() : null"
            >
              {{ item.stock_order_code }}
            </span>
            <br />
            <span
              class="text-no-wrap caption secondary--text"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
            >
              {{ item.created | formatTime }}
            </span>
          </template>
          <template v-slot:item.stock>
            {{ $t("stockOutOrders.Fields.default_stock_name") }}
          </template>
          <!-- 状态 -->
          <template v-slot:item.status="{ item }">
            <span v-if="item.actions.out_re_push">
              <v-chip small label color="danger" text-color="white">
                {{ $t("stockOutOrders.status.pushError") }}
              </v-chip>
            </span>
            <span v-else>
              <v-chip
                small
                label
                :color="item.status | stockOrderOUTStatusColor"
                :text-color="item.status | stockOrderOUTStatusTextColor"
              >
                {{ item.status | stockOrderOUTStatusText }}
              </v-chip>
              <br />
              <v-chip
                v-if="item.cancel_flg"
                x-small
                label
                outlined
                color="danger"
              >
                {{ $t("CRUD.cancelled") }}
              </v-chip>
            </span>
          </template>
          <!-- 完成时间 -->
          <template v-slot:item.finish_time="{ item }">
            {{
              item.type == 3
                ? item.actual_finish_time
                : item.finish_time | formatTime
            }}
          </template>
          <template v-slot:item.actions="{ item }">
            <!-- 操作 -->
            <StockOrderOUTActions
              :pageType="pageType"
              :stock_out="item"
              showView
              showExport
              :showEdit="item.actions.out_edit"
              :showApprove="item.actions.out_approve"
              :showCancel="item.actions.out_cancel"
              :showComplete="item.actions.out_complete"
              :showSheetPrint="item.actions.sheet_print"
              :showRePush="item.actions.out_re_push"
              @done="getStockOutsFromAPI()"
            />
          </template>
        </v-data-table>
      </div>
    </v-sheet>
  </div>
</template>

<script>
import PageAllow from "@/components/PageAllow";
import i18n from "@/i18n";
import Breadcrumbs from "@/components/Breadcrumbs";
import { mapState } from "vuex";
import StockOuts from "@/api/stock_out_orders";
import StockOrderOUTActions from "./plugins/Actions";
import SearcherDatetimeRangeWithRadio from "@/components/plugins/SearcherDatetimeRangeWithRadio";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import SearcherStatus from "@/components/plugins/SearcherStatus";
import SearcherCancelFlgs from "@/components/plugins/SearcherCancelFlgs";
import Shops from "@/api/shops";

const defaultOptions = {
  datetimeRadioSelected: "created",
  created_time_from:
    new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  created_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  actual_time_from: "",
  actual_time_to: "",
  stock_order_code: "",
  status: [2, 3],
  cancel_flgs: [0],
  type: null,
  broken_type: null,
  material_code: "",
};

const defaultProductionOptions = {
  datetimeRadioSelected: "created",
  created_time_from:
    new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  created_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  actual_time_from: "",
  actual_time_to: "",
  stock_order_code: "",
  status: [2, 3],
  cancel_flgs: [0],
  type: 4,
  material_code: "",
};

function getPageType() {
  return document.URL.endsWith("/production-stock-out") ? 2 : 1;
}
function getOptionPrefix() {
  switch (getPageType()) {
    default:
    case 1:
      return "stock-outs";
    case 2:
      return "production-stock-out";
  }
}
function getOptionSelects() {
  switch (getPageType()) {
    default:
    case 1:
      return ["stockOutTypeSelected", "stockOutBrokenTypeSelected"];
    case 2:
      return [];
  }
}
function getDefaultOptions() {
  switch (getPageType()) {
    default:
    case 1:
      return defaultOptions;
    case 2:
      return defaultProductionOptions;
  }
}

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    StockOrderOUTActions,
    SearcherDatetimeRangeWithRadio,
    SearcherKeyword,
    SearcherStatus,
    SearcherCancelFlgs,
  },
  computed: {
    items() {
      return [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text:
            this.pageType == 2
              ? i18n.t("Nav.productionManagement")
              : i18n.t("Nav.stockManagement"),
          disabled: false,
          href: this.pageType == 2 ? "/production-plans" : "/current-stocks",
        },
        {
          text:
            this.pageType == 2
              ? i18n.t("Nav.productionStockOUT")
              : i18n.t("Nav.stockOutOrders"),
          disabled: true,
          href:
            this.pageType == 2 ? "/production-stock-out" : "/stock-out-orders",
        },
      ];
    },
    datetimeRadios: () => [
      {
        key: "created",
        text: i18n.t("stockInOrders.Fields.created_time"),
      },
      {
        key: "actual",
        text: i18n.t("stockInOrders.Fields.actual_time"),
      },
    ],
    headers() {
      let headers = [
        {
          text:
            i18n.t("stockOutOrders.Fields.stock_out_code") +
            " / " +
            i18n.t("stockOutOrders.Fields.created_time"),
          align: "start",
          sortable: false,
          value: "stock_order_code",
        },
      ];
      if (this.pageType != 2) {
        headers.push({
          text: i18n.t("stockOutOrders.Fields.stock_out_obj_name"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "stock_name",
        });
      }
      headers.push(
        {
          text: i18n.t("stockOutOrders.Fields.stock_name"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "stock",
        },
        {
          text: i18n.t("stockOutOrders.Fields.stock_out_type"),
          align: "start",
          sortable: false,
          value: "out_type_str",
        },
        {
          text: i18n.t("stockOutOrders.Fields.detail_count"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "detail_count",
        },
        {
          text: i18n.t("stockOutOrders.Fields.status"),
          align: "start",
          sortable: false,
          value: "status",
        },
        {
          text: i18n.t("stockOutOrders.Fields.finish_time"),
          align: "start",
          sortable: false,
          value: "finish_time",
        },
        {
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        }
      );
      return headers;
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "accountSettings", "stickTableCols", "shopSettings"]),
  },

  mounted() {
    this.$commonUtils.loadOptions(getOptionPrefix(), getOptionSelects()).then(
      function (data) {
        if (data.options) {
          this.options = data.options;
        } else this.resetSearch();

        data.selecteds.forEach((selected) => {
          switch (selected.key) {
            case "stockOutTypeSelected":
              this.stockOutTypeSelected = selected.value;
              break;
            case "stockOutBrokenTypeSelected":
              this.stockOutBrokenTypeSelected = selected.value;
              break;
          }
        });
      }.bind(this)
    );
  },

  data: () => ({
    stockOutsKeyWord: "",
    stockOutTypeSelected: null,
    stockOutBrokenTypeSelected: null,
    stock_outs: [],
    options: JSON.parse(
      sessionStorage.getItem(getOptionPrefix() + "-options")
        ? sessionStorage.getItem(getOptionPrefix() + "-options")
        : JSON.stringify(getDefaultOptions())
    ),
    pageType: getPageType(),
    paging: {},
    currentItemMode: null,
    currentItem: null,
    detailMode: false,
    error_order_id: [],
    materialCode: "",
  }),

  methods: {
    resetSearch() {
      //重置options
      this.stockOutTypeSelected = null;
      this.stockOutBrokenTypeSelected = null;
      this.options = JSON.parse(JSON.stringify(getDefaultOptions()));
      //重置搜索框
      let clearArr = [this.$refs.stock_order_code,this.$refs.material_code];
      clearArr.forEach((k) => {
        if (k) k.clear();
      });
    },
    onSearch() {
      this.options = Object.assign({}, this.options, {
        stock_order_code: this.stockOutsKeyWord,
        material_code: this.materialCode,
      });
    },
    getStockOutsFromAPI() {
      let newOptions = {};
      // 因三个页面共用这一个页面，options在三个页面切换时不能够监测响应到内部键值对的变化，
      // 所以在调用接口前与相应页面的default_option做对比，过滤掉多余的键值对，并重新存入session
      let dfOptions = getDefaultOptions();
      for (let key in this.options) {
        if (
          (dfOptions && typeof dfOptions[key] != "undefined") ||
          typeof this.$consts.tableOptions[key] != "undefined"
        ) {
          newOptions[key] = this.options[key];
        }
      }
      sessionStorage.setItem(
        getOptionPrefix() + "-options",
        JSON.stringify(newOptions)
      );

      StockOuts.fetch(newOptions).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.stock_outs = response.data.stock_outs;
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
        }.bind(this)
      );
    },

    checkActions() {
      Shops.checkAction(1).then(
        function (response) {
          if (response.data.status.isOK()) {
            if (response.data.data.actions) {
              this.$router.push("/stock-out-orders/new");
            } else {
              this.$snackbar.error(i18n.t(response.data.data.msg));
            }
          }
        }.bind(this)
      );
    },
    exportExcel() {
      StockOuts.exports(this.options);
    },
    shopOffReturnOrder() {
      StockOuts.shopOffReturnOrder();
    }
  },

  watch: {
    $route: {
      immediate: true,
      handler() {
        this.pageType = getPageType();
        this.$commonUtils
          .loadOptions(getOptionPrefix(), getOptionSelects())
          .then(
            function (data) {
              if (data.options) {
                this.options = data.options;
              } else this.resetSearch();

              data.selecteds.forEach((selected) => {
                switch (selected.key) {
                  case "stockOutTypeSelected":
                    this.stockOutTypeSelected = selected.value;
                    break;
                  case "stockOutBrokenTypeSelected":
                    this.stockOutBrokenTypeSelected = selected.value;
                    break;
                }
              });
            }.bind(this)
          );
      },
    },
    options: {
      deep: true,
      handler() {
        this.getStockOutsFromAPI();
        sessionStorage.setItem(
          getOptionPrefix() + "-options",
          JSON.stringify(this.options)
        );
      },
    },
    stockOutTypeSelected: {
      handler() {
        this.options.type = this.stockOutTypeSelected
          ? this.stockOutTypeSelected
          : "";
        sessionStorage.setItem(
          getOptionPrefix() + "-stockOutTypeSelected",
          JSON.stringify(this.stockOutTypeSelected)
        );
      },
    },
    stockOutBrokenTypeSelected: {
      handler() {
        this.options.broken_type = this.stockOutBrokenTypeSelected
          ? this.stockOutBrokenTypeSelected
          : "";
        sessionStorage.setItem(
          getOptionPrefix() + "-stockOutBrokenTypeSelected",
          JSON.stringify(this.stockOutBrokenTypeSelected)
        );
      },
    },
  },
};
</script>